import { Button, FormInput, Modal } from '@/components/UI';
import FormSwitch from '@/components/UI/FormSwitch';
import type { OptimizerResultRow } from './types';

interface PromoteResultModalProps {
    result: OptimizerResultRow | null;
    strategyId?: number | null;
    promotionName: string;
    setPromotionName: (value: string) => void;
    promotionDescription: string;
    setPromotionDescription: (value: string) => void;
    promotionIsActive: boolean;
    setPromotionIsActive: (value: boolean) => void;
    promotionAttachToStrategy: boolean;
    setPromotionAttachToStrategy: (value: boolean) => void;
    isWorking: boolean;
    onClose: () => void;
    onPromote: () => void;
}

const PromoteResultModal = ({
    result,
    strategyId,
    promotionName,
    setPromotionName,
    promotionDescription,
    setPromotionDescription,
    promotionIsActive,
    setPromotionIsActive,
    promotionAttachToStrategy,
    setPromotionAttachToStrategy,
    isWorking,
    onClose,
    onPromote
}: PromoteResultModalProps) => {
    return (
        <Modal isOpen={result !== null} size="lg" title="Promote Result" onClose={onClose}>
            {result && (
                <div className="text-zinc-400 text-sm mb-3">
                    resultId={result.id} jobId={result.jobId}
                </div>
            )}

            <div className="space-y-3">
                <FormInput
                    id="opt-promote-name"
                    label="Screener Name"
                    value={promotionName}
                    onChange={(e) => setPromotionName(e.target.value)}
                />
                <FormInput
                    id="opt-promote-description"
                    label="Description"
                    placeholder="Optional"
                    value={promotionDescription}
                    onChange={(e) => setPromotionDescription(e.target.value)}
                />
                <div className="flex items-center justify-between">
                    <FormSwitch
                        checked={promotionIsActive}
                        id="opt-promote-is-active"
                        label="Rule is active"
                        onChange={(e) => setPromotionIsActive(e.target.checked)}
                    />
                    {strategyId ? (
                        <FormSwitch
                            checked={promotionAttachToStrategy}
                            id="opt-promote-attach-strategy"
                            label="Attach to strategy"
                            onChange={(e) => setPromotionAttachToStrategy(e.target.checked)}
                        />
                    ) : (
                        <div className="text-zinc-500 text-sm">No strategy attached to this experiment.</div>
                    )}
                </div>

                <div className="flex items-center justify-end gap-2 pt-2">
                    <Button variant="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button disabled={isWorking} variant="primary" onClick={onPromote}>
                        {isWorking ? 'Working…' : 'Promote'}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default PromoteResultModal;
